/* import __COLOCATED_TEMPLATE__ from './task-card.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';

interface Tag {
  id: string | number;
  name: string;
}

interface TaskContentFragment {
  contentType: number;
  state: number;
  contentId: string;
  contentData: { description?: string };
}

interface Task {
  contentWrapperId: string;
  title: string;
  matchBehavior: number;
  tags: Tag[];
}

interface Signature {
  Args: {
    task: Task;
    firstContent: TaskContentFragment;
    onClick: () => void;
    onDelete: (task: Task) => void;
    liveState: number;
  };
}

const TaskCard = templateOnlyComponent<Signature>();
export default TaskCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksAndProcedures::TaskCard': typeof TaskCard;
  }
}
